import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject, tap} from 'rxjs';
import {LegendResource} from '../resource/legend.resource';
import {LegendDto} from '@maporium-workspace/shared';

@Injectable({providedIn: 'root'})
export class LegendService {
  public currentLegendSubject = new BehaviorSubject<LegendDto | null>(null);
  // Consumers (onboarding tour) request the legend panel open via this stream
  // so they don't need a direct reference to the component (MAP-1245).
  public openRequest$ = new Subject<void>();

  public requestOpen(): void {
    this.openRequest$.next();
  }

  constructor(private resource: LegendResource) {
  }

  // MAP-1245: iframes used to short-circuit to `of(null)`, but the smaplet
  // FTUE needs the legend data to decide whether to show the legend button +
  // bubble 3. The panel component still gates visibility on `hasLegend` in
  // iframe mode, so an empty legend fetch has no visual effect.
  public get(mapId: string) {
    return this.resource.get(mapId).pipe(
      tap((legend) => this.currentLegendSubject.next(legend))
    );
  }

  public getOrCreate(mapId: string) {
    return this.resource.getOrCreate(mapId).pipe(
      tap((legend) => this.currentLegendSubject.next(legend))
    );
  }

  public toggleModelInclusion(modelId: string, mapId: string, included: boolean) {
    return this.resource.toggleModelInclusion(modelId, mapId, included).pipe(
      tap(() => this.get(mapId).subscribe())
    );
  }

  public reorder(mapId: string, items: { modelId: string; order: number }[]) {
    return this.resource.reorder(mapId, items).pipe(
      tap((legend) => this.currentLegendSubject.next(legend))
    );
  }

  public removeModel(modelId: string, mapId: string) {
    return this.resource.removeModel(modelId, mapId).pipe(
      tap(() => this.get(mapId).subscribe())
    );
  }

  public getCurrentLegend(): LegendDto | null {
    return this.currentLegendSubject.value;
  }

  public clearCurrentLegend() {
    this.currentLegendSubject.next(null);
  }
}
